import { $$ } from '@zimpa/dom';
import { $ } from '@zimpa/dom';

const TAGS_CONTAINER_SELECTOR = '.js-tags-container';

const md5 = require('md5');

class ScrollLink {
    private readonly _tags_container: HTMLDivElement;
    public constructor(el: HTMLElement) {
        this._tags_container = <HTMLDivElement>$(TAGS_CONTAINER_SELECTOR, el);
        this.handleItem();
    }

    private addLIHtmlElementsToUL(
        ulHtmlElement: HTMLUListElement | undefined,
        liHtmlElement: HTMLLIElement[],
        targetHTMLToAddList: Element,
    ) {
        if (ulHtmlElement === undefined) {
            return;
        }
        if (liHtmlElement.length <= 0) {
            return;
        }
        for (const tag of liHtmlElement) ulHtmlElement.append(tag);
        targetHTMLToAddList.append(ulHtmlElement);
    }
    private addScrollLinkToList(heading: HTMLElement, result: Element) {
        const scrollLink: HTMLAnchorElement = document.createElement('a');
        scrollLink.innerHTML = heading.innerHTML;
        scrollLink.setAttribute('href', `#${md5(heading.innerHTML)}`);
        result.append(scrollLink);
    }

    private createListElementWithSubHeading(
        heading: HTMLElement,
    ): HTMLLIElement {
        const liTemp: HTMLLIElement = document.createElement('li');
        const scrollLink: HTMLAnchorElement = document.createElement('a');
        scrollLink.innerHTML = heading.innerHTML;
        scrollLink.setAttribute('href', `#${md5(heading.innerHTML)}`);
        liTemp.append(scrollLink);
        return liTemp;
    }

    private handleItem() {
        const targetHTMLToAddList: Element =
            document.getElementsByClassName('js-tags-scroll-bar')[0];
        const sourceHTMLElements: HTMLCollectionOf<Element> =
            document.getElementsByClassName('s-wordpress');
        let ulHtmlElement: HTMLUListElement | undefined = undefined;
        let liHtmlElement: HTMLLIElement[] = [];
        Array.from(sourceHTMLElements).map((sourceElement: HTMLElement) => {
            Array.from(sourceElement.children).map((heading: HTMLElement) => {
                if (heading.nodeName === 'H2') {
                    this.addLIHtmlElementsToUL(
                        ulHtmlElement,
                        liHtmlElement,
                        targetHTMLToAddList,
                    );
                    // Re-initializing as elements are added to target html element, process new list creation.
                    ulHtmlElement = undefined;
                    liHtmlElement = [];
                    //New List Creation
                    this.addScrollLinkToList(heading, targetHTMLToAddList);
                    ulHtmlElement = document.createElement('ul');
                    ulHtmlElement.className = 'c-tags-scroll-ul';
                } else if (heading.nodeName === 'H3') {
                    liHtmlElement.push(
                        this.createListElementWithSubHeading(heading),
                    );
                }
                const scrollAnchor: HTMLSpanElement = document.createElement('span');
                scrollAnchor.setAttribute('id', md5(heading.innerHTML));
                scrollAnchor.className = 'h-scroll-anchor';
                heading.append(scrollAnchor);
            });
        });
        // add last constructed list to result
        this.addLIHtmlElementsToUL(
            ulHtmlElement,
            liHtmlElement,
            targetHTMLToAddList,
        );
        ulHtmlElement = undefined;
        liHtmlElement = [];
        return targetHTMLToAddList;
    }
}
export function scrollLink(): void {
    $$(TAGS_CONTAINER_SELECTOR).map((element: HTMLElement): ScrollLink => {
        return new ScrollLink(element);
    });
}
